import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import { FilterContainer } from 'containers/filterContainer';
import { useInformesFilter } from 'hooks/InformesFilter';
import { useInformFilterDatesError } from 'hooks/informFilterDatesError';
import { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiDatepicker,
  RfUiInput,
  RfUiModal,
  RfUiMultiselect,
  RfUiSelect,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import 'scss/03_generic/literals.scss';
import {
  getAlumnosInforme,
  getEstadosInformes,
  getInformesCursosFilter,
  getProvinciasInformes,
  getSociedadesInformes,
  removeInformeFiltros,
} from 'store/informes/actions';
import {
  makeSelectAlumnosInformesParsed,
  makeSelectCursosInformesParsed,
  makeSelectEstadosInformesParsed,
  makeSelectProvinciasInformesParsed,
  makeSelectSociedadesInformesParsed,
} from 'store/informes/selectors';
import {
  makeSelectFiltros,
  makeSelectNombreFiltro,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
  makeSelectPerfilesUsuarioNombreUsuario,
  makesSelectFiltrosParse,
} from 'store/usuarios/selectors';
import {
  getTodayMinusOneMonthStartDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { language } from 'utils/literals';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { userProfile } from 'utils/profilesIndex';
import { getFiltros, guardarFiltroRequest } from 'store/usuarios/actions';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  sociedades: makeSelectSociedadesInformesParsed(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  nombreUsuario: makeSelectPerfilesUsuarioNombreUsuario(),
  provincias: makeSelectProvinciasInformesParsed(),
  estados: makeSelectEstadosInformesParsed(),
  cursos: makeSelectCursosInformesParsed(),
  alumnos: makeSelectAlumnosInformesParsed(),
  filtro: makeSelectFiltros(),
  filtros: makesSelectFiltrosParse(),
  nombreFiltro: makeSelectNombreFiltro(),
} as any);

const today = new Date().getTime().toString();

export const ReportHoursFilter = ({ handleSubmit }): ReactElement => {

  const {
    profileActive,
    sociedades,
    provincias,
    estados,
    cursos,
    alumnos,
    idUsuario,
    nombreUsuario,
    filtros,
    nombreFiltro,
  } = useSelector<any, any>(selectors);

  const filterRef: any = useRef({});
  const initEstado: any = useRef(null);

  const [sociedadResetKey, setSociedadResetKey] = useState(0);
  const [provinciaResetKey, setProvinciaResetKey] = useState(0);
  const [estadoResetKey, setEstadoResetKey] = useState(0);
  const [cursoResetKey, setCursoResetKey] = useState(0);
  const [alumnoResetKey, setAlumnoResetKey] = useState(0);

  const resetSociedadPending = useRef(true);
  const resetProvinciaPending = useRef(true);
  const resetEstadoPending = useRef(true);
  const resetCursoPending = useRef(true);
  const resetAlumnoPending = useRef(true);
  const cleanFiltersPending = useRef(false);

  const hasMultiselectOptions = (options: any): boolean => {
    if (Array.isArray(options)) {
      return options.length > 0;
    }

    if (typeof options === 'string') {
      try {
        const parsedOptions = JSON.parse(options);

        return Array.isArray(parsedOptions) && parsedOptions.length > 0;
      } catch {
        return false;
      }
    }

    return false;
  };


  useEffect(() => {
    if (
      resetSociedadPending.current &&
      hasMultiselectOptions(sociedades)
    ) {
      setSociedadResetKey(k => k + 1);
      resetSociedadPending.current = false;
    }
  }, [sociedades]);

  useEffect(() => {
    if (
      resetProvinciaPending.current &&
      hasMultiselectOptions(provincias)
    ) {
      setProvinciaResetKey(k => k + 1);
      resetProvinciaPending.current = false;
    }
  }, [provincias]);

  useEffect(() => {
    if (
      resetEstadoPending.current &&
      hasMultiselectOptions(estados)
    ) {
      setEstadoResetKey(k => k + 1);
      resetEstadoPending.current = false;
    }
  }, [estados]);

  useEffect(() => {
    if (
      resetCursoPending.current &&
      hasMultiselectOptions(cursos)
    ) {
      setCursoResetKey(k => k + 1);
      resetCursoPending.current = false;
    }
  }, [cursos]);

  useEffect(() => {
    if (
      resetAlumnoPending.current &&
      hasMultiselectOptions(alumnos)
    ) {
      setAlumnoResetKey(k => k + 1);
      resetAlumnoPending.current = false;
    }
  }, [alumnos]);

  // fechaInicio: getTodayMinus15(),

  const initFilter = {
    estadosCurso: 'IN',
    fechaInicio: getTodayMinusOneMonthStartDate().toString(),
    alumnos:
      profileActive?.ID_PERFIL === '111' ||
      profileActive?.ID_PERFIL === '112' ||
      profileActive?.ID_PERFIL === '121' ||
      profileActive?.ID_PERFIL === '122' ||
      profileActive?.ID_PERFIL === '123'
        ? idUsuario
        : '',
    fechaFin: today,
  };

  const {
    filter,
    setFilter,

    selectedSociedades,
    selectedProvincias,
    selectedEstados,
    selectedCursos,
    selectedFechaDesde,
    selectedFechaHasta,
    selectedAlumnos,

    setSelectedEstados,

    handleSelectedSociedad,
    handleSelectedProvincia,
    handleSelectedFechaDesde,
    handleSelectedFechaHasta,
    handleSelectedEstado,
    handleSelectedCursos,
    handleSelectedAlumnos,

    cleanFilters,

    filterNameAdd,
    selectedFiltros,
    selectedFilterName,
    modalCerradoFiltroGuardarType,
    modalCerradoFiltroEliminarType,
    modalCerradoFiltroEditarType,
    isFilterActive,
    maxDateFromFilter,
    minDateFromFilter,
    optionsFilter,
    selectedOptionFilter,
    handleSelectedFiltros,
    openModalGuardarFiltroCerrado,
    closeModalGuardarFiltroCerrado,
    handleChangeFiltroNombre,
    handleClickConfirmFilterButton,
    openModalEliminarFiltroCerrado,
    closeModalEliminarFiltroCerrado,
    confirmModalEliminarFiltroCerrado,
    openModalEditarFiltroCerrado,
    confirmModalEditarFiltroCerrado,
    closeModalEditarFiltroCerrado,
  } = useInformesFilter(
    {
      sociedades: getSociedadesInformes,
      provincias: getProvinciasInformes,
      cursos: getInformesCursosFilter,
      estados: getEstadosInformes,
      alumnos: getAlumnosInforme,
      filtros: getFiltros,
      removeFiltros: removeInformeFiltros,
    },
    {
      ...initFilter,
    }
  );

  const onSelectedSociedad = (e: any) => {
    resetProvinciaPending.current = true;
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    handleSelectedSociedad(e);
  };

  const onSelectedEstado = (e: any) => {
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    handleSelectedEstado(e);
  };

  const onSelectedProvincia = (e: any) => {
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    handleSelectedProvincia(e);
  };

  const onSelectedCursos = (e: any) => {
    resetAlumnoPending.current = true;

    handleSelectedCursos(e);
  };

  const onSelectedAlumnos = (e: any) => {
    const hayCursosSeleccionados =
      !!filter?.cursos?.trim();

    if (!hayCursosSeleccionados) {
      resetCursoPending.current = true;
    }

    handleSelectedAlumnos(e);
  };

  const errorFechaHasta = useInformFilterDatesError(
    selectedFechaDesde,
    selectedFechaHasta
  );

  useEffect(() => {
    filterRef.current = { ...filter };
    if (cleanFiltersPending.current) {
      cleanFiltersPending.current = false;

      deleteSavedPagination(window.location.pathname);
      handleSubmit(filter);
    }
  }, [filter]);

  const handlerSubmitFilters = () => {
    if (
      profileActive?.ID_PERFIL === '111' ||
      profileActive?.ID_PERFIL === '112' ||
      profileActive?.ID_PERFIL === '121' ||
      profileActive?.ID_PERFIL === '122' ||
      profileActive?.ID_PERFIL === '123'
    ) {
      filterRef.current.alumnos = idUsuario;
    }
    deleteSavedPagination(window.location.pathname);
    handleSubmit(filterRef.current);
  };

  useEffect(() => {
    const estadosArray = JSON.parse(estados);

    if (!estadosArray?.length) {
      return;
    }

    const estadoInit = estadosArray.find(
      (estado: any) => estado.value === 'IN'
    );

    if (!estadoInit) {
      return;
    }
    initEstado.current = estadoInit;

    setSelectedEstados(JSON.stringify([estadoInit]));
    setFilter({ ...filter, estadosCurso: estadoInit.value });
  }, [estados]);

  const handleCleanFilters = () => {
    resetSociedadPending.current = true;
    resetProvinciaPending.current = true;
    resetEstadoPending.current = true;
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    cleanFiltersPending.current = true;

    cleanFilters();
  };

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>
        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            {(profileActive?.ID_PERFIL === userProfile.administrador || profileActive?.ID_PERFIL === userProfile.supervisor) ? (
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  key={`multiselect-sociedades-${sociedadResetKey}`}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  textLabel="Sociedad"
                  placeholder="Seleccione sociedad"
                  defaultChecks={selectedSociedades}
                  options={sociedades}
                  onOptionSelected={onSelectedSociedad}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              </div>
            ) : null}
            <div className="rf-practice-list__input-container rf-practice-list__input-container--desde-reducer-mb">
              {/* <div className="rf-practice-list__input-container"> */}
              <RfUiMultiselect
                key={`multiselect-provincias-${provinciaResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Provincia"
                placeholder="Seleccione provincia"
                defaultChecks={selectedProvincias}
                options={provincias}
                onOptionSelected={onSelectedProvincia}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>

            <p className="literals-date">
              Fecha desde - hasta hace referencia a fecha de inicio de curso
            </p>
            <div className="rf-box__child">
              <div className="rf-practice-detail__input-container rf-practice-list__input-container--pr rf-practice-list__input-container--hasta-reducer-mb">
                <RfUiDatepicker
                  moment-locale="es"
                  labelInput="Desde"
                  disabled={false}
                  onDateSelected={(e: any) => {
                    handleSelectedFechaDesde(e);
                  }}
                  defaultDateFrom={isFilterActive ? minDateFromFilter : selectedFechaDesde}
                  // defaultMaxDateFrom={today}
                  defaultMaxDateFrom={selectedFechaHasta}
                ></RfUiDatepicker>
              </div>
            </div>
            <div className="rf-box__child">
              <div className="rf-practice-detail__input-container rf-practice-list__input-container--section-reducer-mb">
                <RfUiDatepicker
                  moment-locale="es"
                  labelInput="Hasta"
                  disabled={false}
                  onDateSelected={(e: any) => {
                    handleSelectedFechaHasta(e);
                  }}
                  defaultDateFrom={isFilterActive ? maxDateFromFilter : selectedFechaHasta}
                  defaultMaxDateFrom={today}
                  defaultMinDateFrom={selectedFechaDesde}
                ></RfUiDatepicker>
                <ErrorMessage message={errorFechaHasta}></ErrorMessage>
              </div>
            </div>
          </div>
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-estados-${estadoResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Estado"
                placeholder="Seleccione estado"
                defaultChecks={selectedEstados}
                options={estados}
                onOptionSelected={onSelectedEstado}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-cursos-${cursoResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Curso"
                placeholder="Seleccione curso"
                defaultChecks={selectedCursos}
                options={cursos}
                onOptionSelected={onSelectedCursos}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__input-container">
              {profileActive?.ID_PERFIL === '111' ||
                profileActive?.ID_PERFIL === '112' ||
                profileActive?.ID_PERFIL === '121' ||
                profileActive?.ID_PERFIL === '122' ||
                profileActive?.ID_PERFIL === '123' ? (
                <RfUiInput
                  label="Alumno"
                  value={idUsuario + ' - ' + nombreUsuario}
                  disabled={true}
                  error=""
                  placeholder="Seleccione alumno"
                />
              ) : (
                <RfUiMultiselect
                  key={`multiselect-alumnos-${alumnoResetKey}`}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  textLabel="Alumnos"
                  placeholder="Seleccione alumno"
                  defaultChecks={selectedAlumnos}
                  options={alumnos}
                  onOptionSelected={onSelectedAlumnos}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiSelect
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                options={filtros}
                defaultChecked={selectedFiltros}
                label="Filtros"
                onOptionActive={handleSelectedFiltros}
                placeholder="Seleccione Filtro"
                optionFilter={selectedOptionFilter}
                onEdit={openModalEditarFiltroCerrado}
                onDelete={openModalEliminarFiltroCerrado}
              />
            </div>
          </div>
          <div
            className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                ? 'rf-block--mobile rf-text-align-center--mobile'
                : ''
              }`}
          >
            <RfUiButton
              text="Guardar filtros"
              text-help="Guardar filtros"
              aspect="secondary"
              onButtonClick={() => {
                openModalGuardarFiltroCerrado();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Limpiar filtros"
              text-help="Limpiar filtros"
              aspect="secondary"
              onButtonClick={() => {
                handleCleanFilters();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Filtrar"
              type="button"
              aspect="primary"
              className="rf-button rf-margin-left-30"
              onButtonClick={() => {
                handlerSubmitFilters();
              }}
              disabled={!!errorFechaHasta}
            >
              {' '}
            </RfUiButton>
          </div>
        </form>
        <div>
          <RfUiModal
            title-Modal={'Nombre filtro'}
            id-modal="empty"
            modal-type={modalCerradoFiltroGuardarType}
            slot-content={true}
            onModalClose={(e: any) => {
              closeModalGuardarFiltroCerrado();
            }}
            onConfirm={() => {
              handleClickConfirmFilterButton();
            }}
          >
            <div slot="content">
              <FilterContainer
                title={language.filter.filterName}
                valueFilter={nombreFiltro}
                handleFilterChange={handleChangeFiltroNombre}
              />
            </div>
            <div slot="content">
              <RfUiButton
                disabled={!filterNameAdd}
                text={language.filter.sendConfirm}
                type="button"
                aspect="white"
                className="rf-button"
                onButtonClick={handleClickConfirmFilterButton}
              >
              </RfUiButton>
            </div>
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`Usted va a editar el filtro: ${selectedFilterName}`}
            id-modal="moralEdit"
            modal-type={modalCerradoFiltroEditarType}
            required-slot={false}
            onModalClose={() => {
              closeModalEditarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEditarFiltroCerrado(selectedFilterName);
            }}
          >
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`¿Esta seguro de que quiere eliminar el filtro? ${selectedFilterName}`}
            id-modal="modalDelete"
            modal-type={modalCerradoFiltroEliminarType}
            required-slot={true}
            onModalClose={(e: any) => {
              closeModalEliminarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEliminarFiltroCerrado()
            }}
          >
          </RfUiModal>
        </div>
      </RfUiAccordionCustom>
    </>
  );
};
